export function assertParams({
  target,
  fields,
  ErrorCtor = Error,
  messagePrefix = '',
}) {
  fields.forEach((field) => {
    if (!target[field]) {
      throw new ErrorCtor(`${messagePrefix}${field} is required`)
    }
  })
}
